module.exports = __webpack_public_path__ + "static/media/Andover-Lake-bylaws.3a4998c6.pdf";